module.exports = __webpack_public_path__ + "img/DXTrade.69a84e07.png";